module.exports = __webpack_public_path__ + "fonts/lato-italic-webfont.17f42929.woff2";